import { flatten } from './flatten-helper';
import { State } from '@progress/kendo-data-query';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchHelperService
{
  /**
   * Provide helper method for search filter change event.
   */
  public fieldChange(filterText: any, state: State, searchField = 'name',
    searchOperator = 'contains'): any
  {
    const root = state.filter || { logic: 'and', filters: [] };
    const [filter] = flatten(root).filter(x => x.field === searchField);

    if (filterText === '')
    {
      const index = root.filters.findIndex((obj: any) => obj.field === searchField);
      root.filters.splice(index, 1);
    }
    else
    {
      if (!filter)
      {
        root.filters.push({
          field: searchField,
          operator: searchOperator,
          value: filterText
        });
      } else
      {
        filter.value = filterText;
      }
    }
    return root;
  }
}
